'use strict';
var parent = require('../../stable/instance/reduce');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/reduce.js
// module id = 535
// module chunks = 13